import React from 'react';
import type { Organizer } from '@/types';
import { AvatarComponent } from './AvatarComponent/AvatarComponent';

interface OrganizerAvatarProps {
  organizer: Organizer;
  size?: 'small' | 'large';
}

export const OrganizerAvatar: React.FC<OrganizerAvatarProps> = ({ organizer, size = 'large' }) => {
  return <AvatarComponent organizer={organizer} size={size} />;
};
